export default __webpack_public_path__ + "static/media/ep1collage5.c45306ec.jpg";